import { ReactNode, Suspense } from "react";

import Navbar from "./Navbar";

interface PropsType {
  children: ReactNode;
  childrentFooter?: ReactNode;
}

function Template({ children }: PropsType) {

  return (
    <div className="h-full flex flex-col items-center">
      <Suspense>
        <Navbar />
      </Suspense>
      <div className="w-full flex-1 overflow-y-auto no-scrollbar">
        <main className="max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Template;